import React from 'react'
import './CrossClientUnauthorized.scss'
import { Divider } from '../../../components/Divider/Divider'

export const CrossClientUnauthorized: React.FC = () => {
  return (
    <div className='d-flex flex-column align-items-center text-center zocks-gap-4 mt-2'>
      <div className='d-flex flex-column zocks-gap-0.75 align-items-center'>
        <h2>Client Queries is available to Account Owner and Admins only</h2>
        <div className='paragraph-large cross-client-unauthorized-text-container'>
          We're expanding access to all team members soon. Your Account Owner or Admins will let you know when it's available.
        </div>
        <div className='paragraph-large'>Want to try it? Send your questions to Account Owner or Admins.</div>
      </div>
      <Divider />
      <div className='d-flex flex-column zocks-gap-2'>
        <div className='d-flex flex-column zocks-gap-0.75 align-items-center'>
          <h2>What is Client Queries?</h2>
          <div className='paragraph-large cross-client-unauthorized-text-container'>
            Ask who you're looking for in plain English. Get an actionable list of clients. No spreadsheets, filters, or manual searching required.
          </div>
        </div>
        <div className='cross-client-unauthorized-video-container'>
          <video
            src='https://static.zocks.io/assets/ccq/ccq_teaser.mp4'
            className='w-100 cross-client-waitlist-video zocks-border-0.5'
            controls
            muted
            autoPlay
            playsInline
            preload='metadata'
          />
        </div>
      </div>
    </div>
  )
}
